import React from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { UICoupon } from "../Coupons"
import { useTranslation } from "react-i18next"

const CouponActionMenus = ({
  coupon,
  editCouponHandler,
  viewDetailsHandler,
  deleteCouponHandler,
  addOfferHandler,
  addCompaign,
  autoAssignToDelivery,
}: {
  coupon: UICoupon
  editCouponHandler: (coupon: UICoupon) => void
  viewDetailsHandler: (coupon: UICoupon) => void
  deleteCouponHandler: (coupon: UICoupon) => void
  addOfferHandler: (coupon: UICoupon) => void
  addCompaign: (coupon: UICoupon) => void
  autoAssignToDelivery: (coupon: UICoupon) => void
}) => {
  const { t } = useTranslation()

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-vertical font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem onClick={() => editCouponHandler(coupon)}>
          <span className="">{t("common_edit")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => viewDetailsHandler(coupon)}>
          <span className="">{t("common_viewDetails")}</span>
        </DropdownItem>
        {/* <DropdownItem onClick={() => addOfferHandler(coupon)}>
          <span className="">{t("common_addOffer")}</span>
        </DropdownItem> */}
        {/* <DropdownItem onClick={() => addCompaign(coupon)}>
          <span className="">{t("common_addCompaign")}</span>
        </DropdownItem> */}
        <DropdownItem onClick={() => autoAssignToDelivery(coupon)}>
          <span className="">{t("common_autoAssignToDelivery")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => deleteCouponHandler(coupon)}>
          <span className="text-danger">{t("coupons_deleteCoupon")}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default CouponActionMenus
